import Modal from 'antd-mobile/lib/modal';
import 'antd-mobile/lib/modal/style/css';
import './styles.scss';
import './goods_detail.scss';

export { default as Tips } from './Tips';
export { default as BottomPopup } from './BottomPopup';

export default Modal;

export { popup, popup as popupShow, hide as popupHide } from './BottomPopup/BottomPopupContainer';

export { show as showTips, hide as hideTips } from './Tips/TipsContainer';
